export default __webpack_public_path__ + "static/media/runnerup_3.0efe61cb.jpg";